// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"5964b0a5","266":"1e59223d","606":"68105091","657":"c4631a50","753":"3dadab50"}[chunkId] + ".css";
};